import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tutorial" }

import { Component } from 'vue'
import { BookTutorial, BookTutorialStep } from '@/models/doc.tutorial'

import SidebarTutorialStepFavorite from './SidebarTutorialStepFavorite.vue'
import SidebarTutorialStepFonts from './SidebarTutorialStepFonts.vue'
import SidebarTutorialStepNight from './SidebarTutorialStepNight.vue'
import SidebarTutorialStepPlayer from './SidebarTutorialStepPlayer.vue'
import SidebarTutorialStepTOC from './SidebarTutorialStepTOC.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarTutorial',
  props: {
    bookTutorial: {}
  },
  setup(__props: any) {

enum BookTutorialSidebarStep {
  fonts = BookTutorialStep.fonts,
  toc = BookTutorialStep.toc,
  player = BookTutorialStep.player,
  favorite = BookTutorialStep.favorite,
  night = BookTutorialStep.night,
}

/* We use dynamic rendering for sidebar tutorial steps because there are books
 * that don't have audio narrations and we need to skip Player button step. The
 * CSS is made the way it uses n-th child selectors, so if we just hide the step
 * (with v-if of v-show) it's still present in the DOM, which makes all further
 * steps misaligned, so we need to actually add only the needed components to
 * the Tutorial Sidebar - thus we use dynamic rendering here.
 */
const COMPONENTS = {
  [BookTutorialSidebarStep.fonts]: SidebarTutorialStepFonts,
  [BookTutorialSidebarStep.toc]: SidebarTutorialStepTOC,
  [BookTutorialSidebarStep.player]: SidebarTutorialStepPlayer,
  [BookTutorialSidebarStep.favorite]: SidebarTutorialStepFavorite,
  [BookTutorialSidebarStep.night]: SidebarTutorialStepNight,
}



function componentName(step: BookTutorialSidebarStep): Component {
  return COMPONENTS[step]
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.bookTutorial.sidebarSteps(), (step) => {
      return (_openBlock(), _createBlock(_resolveDynamicComponent(componentName(step)), {
        key: step,
        bookTutorial: __props.bookTutorial
      }, null, 8, ["bookTutorial"]))
    }), 128))
  ]))
}
}

})